// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container_buttons__\\+iiUW{
    align-items: center;
    cursor: pointer;
    display: flex;
    justify-content: flex-end;
}

.styles_title__jv-Bj{
    background: #f3f3f3;
    border: 1px solid #dadada;
    border-radius: 7px 0 7px 7px;
    margin-right: .1rem;
    padding: .3rem .8rem;
}

.styles_title__jv-Bj:hover{
    color: #fff;
    background: #1c3988;
}`, "",{"version":3,"sources":["webpack://./src/components/SpeedDial/styles.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,4BAA4B;IAC5B,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB","sourcesContent":[".container_buttons{\n    align-items: center;\n    cursor: pointer;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.title{\n    background: #f3f3f3;\n    border: 1px solid #dadada;\n    border-radius: 7px 0 7px 7px;\n    margin-right: .1rem;\n    padding: .3rem .8rem;\n}\n\n.title:hover{\n    color: #fff;\n    background: #1c3988;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_buttons": `styles_container_buttons__+iiUW`,
	"title": `styles_title__jv-Bj`
};
export default ___CSS_LOADER_EXPORT___;
